module.exports = __webpack_public_path__ + "static/media/product1.e404ed42.png";